import type { CustomerWinnersFeedResponse } from '@/types/models';

export type Winner = CustomerWinnersFeedResponse['data'][0];

export const NO_TOP_PRIZE_INDEX = -1;

export const isMainPrize = (winner: Winner): boolean => winner.type === 'MAIN';

export const getTopPrizeIndex = (winners: Winner[]): number =>
  winners.reduce(
    (topIndex, winner, index) =>
      isMainPrize(winner) &&
      (topIndex === NO_TOP_PRIZE_INDEX || winner.value > winners[topIndex].value)
        ? index
        : topIndex,
    NO_TOP_PRIZE_INDEX,
  );

export const getWinnerKey = (winner: Winner, index: number): string =>
  `${winner.sequence}-${winner.date}-${index}`;
